<template>
	<answer-inputtext
		class="element element--inputtext"
		:element-translation="i18n ? elementTranslation.found : elementTranslation.missing"
		:output="i18n ? $t(`${output}`) : output"
	>
		<input
			v-if="inputExpanded"
			ref="input"
			class="element__input"
			:value="value"
			:name="name"
			:id="id"
			:type="type"
			:inputmode="inputmode"
			:placeholder="placeholder"
			:pattern="pattern"
			:maxlength="maxlength"
			:required="required"
			@keyup="keyEvent"
		/>
		<button
			ref="toggleButton"
			v-if="toggle"
			class="element__button element__button--toggle"
			@click="doToggle"
		>
			{{ $t('toggle') }}
		</button>
		<button v-if="clearable && value !== ''" class="element__button element__button--clear" @click="clear">
			{{ $t('clear') }}
		</button>
	</answer-inputtext>
</template>

<script>
import Vue from 'vue';
import { elementTranslation } from '../../tools/consts';
export default {
	props: {
		value: [String, Number, Boolean, Array],
		name: String,
		id: String,
		type: String,
		inputmode: String,
		pattern: String,
		i18n: Boolean,
		output: String,
		placeholder: String,
		maxlength: String,
		clearable: Boolean,
		toggle: Function,
		required: Boolean,
		autoExpand: Boolean,
	},
	data() {
		return {
			inputExpanded: false,
		};
	},
	methods: {
		keyEvent(event) {
			this.$emit('keyup', event);
			this.$emit('input', event.target.value);
		},
		focus() {
			if (this.$refs.input) this.$refs.input.focus();
			else {
				this.$refs.toggleButton.focus();
			}
		},
		blur() {
			if (this.$refs.input) this.$refs.input.blur();
		},
		clear() {
			this.$emit('input', '');
		},
		doToggle() {
			// catchFocus();
			if (this.inputExpanded) {
				this.clear();
				//	window.focus();
				if (this.toggle) {
					this.toggle();
				}
			} else {
				if (this.toggle) {
					this.toggle();
				}
				// Do not changes this weired Timout things this is causes of shit safari focus behaviour
				Vue.nextTick(() => {
					this.focus();
				});
			}
			this.inputExpanded = !this.inputExpanded;
		},
	},
	created() {
		this.elementTranslation = elementTranslation;
		if (this.autoExpand) {
			this.inputExpanded = true;
		}
	},
	mounted() {},
};
</script>
